import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

class Logout extends React.Component {
  componentDidMount() {
    this.props.logout(this.props.router)
  }

  render() {
    return <div />
  }
}

Logout.propTypes = {
  router: PropTypes.any,
  logout: PropTypes.func.isRequired,
}

export default withRouter(Logout)
